<div class="break-inside-avoid">
  <h2 rmaBackToMap class="mat-headline-4 mb-8 text-center" [selectedItemId]="selectedItemId">
    {{ 'marketReports.comparable-properties-header' | transloco }}
  </h2>

  @if (markers$ | async; as markers) {
    @if ((isPrintMode && printedUrl) || markers.length) {
      <rma-market-report-comparable-properties-map
        class="w-full pb-6"
        [class.h-80]="!isPrintMode"
        [isPrintMode]="isPrintMode"
        [printedUrl]="printedUrl"
        [markers]="markers"
        (markerSelected)="onMarkerSelected($event)"
      />
    }
  }
</div>

<rma-market-report-comparable-property-tiles [comparableCampaigns]="comparableCampaigns" [selectedItemId]="selectedItemId" />
